// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
// Monitoring tab: resource-metrics snapshot, CPU/memory history charts, the
// usage-analytics band, the diagnostics snapshot, and the live log tail —
// runtime observability in one place.
import * as React from 'react';

import { useCurrentUser } from '@/lib/auth';

import { AppDiagnosticsPanel } from './AppDiagnosticsPanel';
import { AppMetricsPanel } from './AppMetricsPanel';
import { AppUsagePanel } from './AppUsagePanel';
import { CrashLoopBanner } from './CrashLoopBanner';
import { LogsTab } from './LogViewer';

/**
 * Runtime observability in one place: the resource-metrics snapshot, the
 * CPU/memory history charts, the usage band, the diagnostics snapshot, and the
 * live log tail.
 */
export function MonitoringTab({ appId }: { appId: string }): React.JSX.Element {
  const user = useCurrentUser();
  // The usage read is IT-gated (governance read set) — owners viewing their
  // own app's Monitoring tab don't get the panel rather than seeing it 403.
  const isIT = user?.role === 'org_admin' || user?.role === 'admin';
  return (
    <div className="space-y-4" data-testid="monitoring-tab">
      <AppMetricsPanel appId={appId} />
      {isIT && <AppUsagePanel appId={appId} />}
      <AppDiagnosticsPanel appId={appId} />
      <CrashLoopBanner appId={appId} />
      <LogsTab appId={appId} />
    </div>
  );
}
